
const customLocalStorage = {
    currency: localStorage.hasOwnProperty("currency") ? localStorage.getItem("currency") : 'PLN',
    language: localStorage.hasOwnProperty("language") ? localStorage.getItem("language") : 'PL'
}
export default customLocalStorage;
